export const BILLING_WARNING_STATUSES = ['past_due', 'unpaid', 'canceled', 'incomplete'];
export const BILLING_INVOICE_COLUMNS = [
    'index',
    'date',
    'plan',
    'seats',
    'devices',
    'amount',
    'status',
    'invoice',
    'receipt',
];

export const BILLING_STATUS_CLASSES: Record<string, string> = {
    paid: 'paid',
    failed: 'failed',
    open: 'open',
    void: 'void',
};

export const BILLING_CARD_BRAND_FILES: Record<string, string> = {
    visa: 'visa.svg',
    mastercard: 'mastercard.svg',
    master_card: 'mastercard.svg',
    amex: 'amex.svg',
    american_express: 'amex.svg',
    discover: 'discover.svg',
    discover_global_network: 'discover.svg',
    diners: 'diners.svg',
    diners_club: 'diners.svg',
    jcb: 'jcb.svg',
    unionpay: 'unionpay.svg',
    union_pay: 'unionpay.svg',
    maestro: 'maestro.svg',
    mir: 'mir.svg',
    interac: 'interac.svg',
    rupay: 'rupay.svg',
    hipercard: 'hipercard.svg',
};

export const BILLING_CARD_BRAND_FALLBACK = 'generic.svg';
